import { RouteUrlList } from '@/libs/RouteList';
const LoginCheck = [
    'POST',
    RouteUrlList.API_CheckIfLogin.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: 'OK',
        errorCode: '',
        data: {
            token: '34HafsdDt6235SFafsdf=='
        }
    }
];
export default LoginCheck;
